import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, computed, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { QuillModule } from 'ngx-quill';
import { FormGroupService } from 'src/app/components/form-group/form-group.service';
import { FormGroupModel, Mode } from 'src/app/components/form-group/form-group.types';
import { TabSectionComponent } from 'src/app/components/form-group/tab-section/tab-section.component';

@Component({
    selector: 'service-site-form-group',
    imports: [
        FormsModule,
        MatFormFieldModule,
        TabSectionComponent,
        QuillModule
    ],
    templateUrl: './form-group.component.html',
    styleUrl: './form-group.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormGroupComponent implements OnInit {
  readonly #formGroupService = inject(FormGroupService);
  readonly #cd = inject(ChangeDetectorRef);

  @Input() id!: string;

  readonly mode = signal<Mode>('loading');
  readonly formData = signal<FormGroupModel | null>(null);
  readonly element: Record<string, string> = {};

  readonly termsCheck = signal(false);
  readonly termsError = signal(false);
  readonly showMatError = computed(() => {
    return !this.termsCheck() && this.termsError();
  });

  constructor() {
    effect(() => {
      const agree = this.termsCheck();
      if (agree) {
        this.termsError.set(false);
      }
    }, { allowSignalWrites: true });
  }

  ngOnInit() {
    this.#formGroupService.get(this.id)
      .subscribe(res => {
        this.formData.set(res);
        if (window.location.pathname === res.completeUrl) {
          this.mode.set('complete');
          return;
        }
        this.mode.set('form');
      })
      .add(() => this.#cd.markForCheck());
  }

  send() {
    if (!this.#check()) {
      this.#formGroupService.markAsTouched();
      return;
    }
    let data: string | null = sessionStorage.getItem('utm_source');
    if (data) {
      this.element['utm_source'] = data;
    }
    data = sessionStorage.getItem('utm_medium');
    if (data) {
      this.element['utm_medium'] = data;
    }
    data = sessionStorage.getItem('utm_campaign');
    if (data) {
      this.element['utm_campaign'] = data;
    }
    this.#formGroupService.answer(this.id, this.element)
      .subscribe(() => {
        window.location.href = this.formData()!.completeUrl;
        this.#cd.markForCheck();
      });
  }

  #check() {
    if (!this.termsCheck()) {
      this.termsError.set(true);
      return false;
    }

    for (const key of this.#formGroupService.keys) {
      if (!this.element[key]) {
        return false;
      }
    }

    return true;
  }
}
